import { getConfig } from '@config/index'

const config = getConfig()

export const getSessionTransferUrl = (
  sessionTransferDomain: string,
  {
    rpHost,
    rpPath = '/',
    additionalParams = '',
  }: { rpHost: string; rpPath?: string; additionalParams?: string },
) => {
  const encodedRpHost = encodeURIComponent(rpHost)
  const encodedRpPath = encodeURIComponent(rpPath)

  return `${sessionTransferDomain}?rp_host=${encodedRpHost}&rp_path=${encodedRpPath}&${additionalParams}`
}

/**
 * Creates session transfer url to grammarly.
 * Adds container id to query param. It will be consumed by the grammarly client later.
 * At the time of writing only funnel uses and removes the sh_cid query param (cms does not).
 */
export const getGrammarlySessionTransferUrl = (params: {
  rpPath: string
  rpPathQuery: Record<string, unknown>
  containerId: string
}) => {
  const additionalParams = new URLSearchParams({
    ...params.rpPathQuery,
    sh_cid: params.containerId,
  }).toString()

  return getSessionTransferUrl(config.sessionTransfer.toGrammarly, {
    rpHost: config.domains.grammarly,
    rpPath: params.rpPath,
    additionalParams,
  })
}
